var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-arrow-back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2,7H3.7l4.1-4.7c0.4-0.4,0.3-1-0.1-1.4C7.3,0.6,6.7,0.6,6.3,1L0.7,7.3c0,0-0.1,0.1-0.1,0.2 c0,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.2-0.1,0.4c0,0,0,0,0,0s0,0,0,0c0,0.1,0,0.2,0.1,0.4c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2 L6.3,15c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3c0.4-0.4,0.5-1,0.1-1.4L3.7,9h12.5c0.6,0,1-0.4,1-1S16.8,7,16.2,7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.05547d3f2eeb59cae11bfd1198ad35da.svg";
export { ForwardRef as ReactComponent };